import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ParametresInstance } from "../../Controls/Parameters";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class modalOuverturePremierExercice extends Vue {
	public moisSelectionne?: number;
	public anneeSelectionnee?: number;
	public isLoading = false;

	public init(): void {
		if (ParametresInstance.societeCourante == undefined) {
    		return;
    	}

    	this.isLoading = true;

    	$("#modalOuverturePremierExercice").modal("show");

    	this.initExerciceParDefaut();

    	this.isLoading = false;
	}

	public initExerciceParDefaut(): void {
		const anneeExerciceEnCours = ParametresInstance.societeCourante?.AnneeExerciceEnCours;
    	const moisExerciceEnCours = ParametresInstance.societeCourante?.MoisExerciceEnCours;
    	if (anneeExerciceEnCours != undefined && moisExerciceEnCours != undefined) {
    		this.anneeSelectionnee = anneeExerciceEnCours;
    		this.moisSelectionne = moisExerciceEnCours;
    	} else {
    		const date = new Date();
    		this.anneeSelectionnee = date.getUTCFullYear();
    		this.moisSelectionne = date.getUTCMonth() + 1;
    	}
	}

	public annuler(): void {
    	$("#modalOuverturePremierExercice").modal("hide");
	}

	public valider(): boolean | void {
		if (!this.anneeSelectionnee || !this.moisSelectionne) {
    		NotificationServiceInstance.SendFailed("L'année et le mois doivent être renseignés");

    		return;
    	}
		if (isNaN(Number(this.anneeSelectionnee)) || isNaN(Number(this.moisSelectionne))) {
    		NotificationServiceInstance.SendFailed("L'année et le mois doivent être des entiers");

    		return;
    	}

    	this.isLoading = true;

    	ServicesFactoryInstance.ExercicesService.creerExerciceInitial(this.anneeSelectionnee, this.moisSelectionne, () => {
    		NotificationServiceInstance.SendSuccess("L'exercice a bien été ouvert.");
    		this.isLoading = false;
    		if (ParametresInstance.societeCourante != undefined) {
    			ParametresInstance.societeCourante.AnneeExerciceEnCours = this.anneeSelectionnee;
    			ParametresInstance.societeCourante.MoisExerciceEnCours = this.moisSelectionne;
    		}

    		this.$emit("refreshListeExercices");
    		this.annuler();
    	},
    	() => {
    		NotificationServiceInstance.SendFailed("L'exercice n'a pas pu être ouvert.");
    		this.isLoading = false;
    		this.annuler();
    	}
    	);
	}
}




// WEBPACK FOOTER //
// ./src/components/modalComponents/modalOuverturePremierExercice/modalOuverturePremierExercice.ts